package com.shadowings.gero.data.lessons.chapter7

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.*

fun getSevenEndingContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_alyn_1,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_nilo_2,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_alyn_2,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_nilo_3,
            face = Faces.Sad,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_seven_ending,
            content = Res.string.exp_content_seven_ending_nilo_4,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getSevenEndingQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val pool = mutableListOf<IQuizContent>()
    pool.addAll(getVocabVso1QuizContent(getVocabVso1Content(words, languageCode), words, languageCode))
    pool.addAll(getVocabVso2QuizContent(getVocabVso2Content(words, languageCode), words, languageCode))
    pool.addAll(getVocabVso3QuizContent(getVocabVso3Content(words, languageCode), words, languageCode))
    return pool
}
